import Header from "../components/Header";
import Footer from "../components/Footer";
import ContactForm from "../components/contact-form";
import contactHeroImage from "../images/contact-hero.png";

const ContactPage = () => {

  return (
    <div>
      <Header />

      <section className="contact-hero-section d-flex align-items-center">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 hero-content">
              <span className="portfolio-hero-subtitle">Contact</span>
              <div className="hedding process-underline-flex">
                <div className="process-underline"></div>
                <div className="process-underline"></div>
              </div>
              <p className="contact-subtitle">
                With over 20 years of experience, Hope Web Solutions has
                successfully delivered innovative and reliable digital solutions
                across diverse industries. From custom mobile applications and
                dynamic web platforms to AI-powered systems, our portfolio
                reflects our commitment to quality and client satisfaction.
              </p>
            </div>

            <div className="col-lg-6 hero-image text-center mt-lg-0 pt-5 justify-content-end contect-hero-img">
              <img
                src={contactHeroImage}
                alt="Hero Main"
                className="img-fluid main-hero-img"
              />
            </div>
          </div>
        </div>
      </section>

      <ContactForm />
      <Footer />
    </div>
  );
};

export default ContactPage;
